<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Permisson', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-8">
      <block :nobody="true" ref="buser" class="soft-control">
        <div class=" py-8 px-4">
          <h3>Bạn không được cấp quyền để truy cập trang này</h3>
        </div>
      </block>
    </div>
  </div>
</template>
<script>
export default {
  name: "permission",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss"></style>
